import { Breadcrumb, Layout } from 'antd'
import { Link, useRouteMatch, withRouter } from 'react-router-dom'
import GraphConsole from 'Pages/Explore/RightPanel/GraphView/Graph/GraphConsole'
import { FormProvider } from './Context'
import FormsContainer from './FormsContainer'
import './index.scss';


function CreateTask ({ history }) {
  const { params: { spaceId, taskId }} = useRouteMatch()

  return (
    <FormProvider>
      <Layout>
        <Breadcrumb style={{ margin: 20, marginBottom: 0 }}>
          <Breadcrumb.Item>
            { Weaver.getInstance().currentProject()?.name() }
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/${ spaceId }/pipelines/tasks`}>
              Tasks
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            { taskId }
          </Breadcrumb.Item>
        </Breadcrumb>
        <FormsContainer history={history}/>
        <GraphConsole
          isHidden={false}
          sparqlOnly={true}
          saveQueryAsView={false}
        />
      </Layout>
    </FormProvider>
  )
}

export default withRouter(CreateTask)
